import React from 'react';
import { useShowContext } from 'ui-builder';
import { PlanTask } from 'nekst-api';
import styles from './IsAiTask.module.scss';

export default function IsAiTaskField() {
  const context = useShowContext<PlanTask>();

  if (context?.data.isAiTask) {
    return (
      <i className={styles.icon} title="AI Task">
        &nbsp;
      </i>
    );
  } else {
    return null;
  }
}
